<template>
  <div class="white pa-4 top-clientes-container">
    <v-card flat>
      <v-card-title class="text-h6 font-weight-bold">
        TOP CLIENTES
      </v-card-title>
      <v-card-text>
        <!-- FILTROS -->
        <v-row align="end" class="mb-4">
          <v-col cols="12" md="2">
            <div class="filter-label">Desde</div>
            <date-picker
              v-model="start"
              :value="start"
              @dateSelected=" (val) => { start = val;}"
              type="date"
              styling-mode="underlined"
              width="100%"
            />
          </v-col>
          <v-col cols="12" md="2">
            <div class="filter-label">Hasta</div>
            <date-picker
              v-model="end"
              :value="end"
              @dateSelected=" (val) => { end = val;}"
              type="date"
              styling-mode="underlined"
              width="100%"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-checkbox
              v-model="mostrarVendedor"
              label="Mostrar vendedor"
              hide-details
              class="mt-2"
              @click="getTopCustomers()"
            />
          </v-col> 
          <v-col cols="12" md="2">
            <v-checkbox
              v-model="mostrarIVA"
              label="Mostrar con IVA"
              hide-details
              class="mt-2"
              @click="getTopCustomers()"
            />
          </v-col>
          <v-col cols="12" md="2">
            <DxButton
              text="Filtrar"
              type="default"
              styling-mode="contained"
              width="100%"
              @click="getTopCustomers"
            />
          </v-col>
          <v-col cols="12" md="2">
            <DxButton
              text="Limpiar"
              type="success"
              styling-mode="contained"
              width="100%"
              @click="topCustomers = HistorytopCustomers; search = { filter: null}"
            />
          </v-col>
        </v-row>
        <spinner v-if="loading" />
        <GeneralFilter
          :search="search"
          :filterEndpoint="filterPromise"
          @filtered="filterHandler"
          @emptyFilter="clearFilter"
          style="width:100%"
          v-else
        >
          <DxDataGrid
            :data-source="topCustomers"
            key-expr="ID_Customer"
            :scrolling="{ useNative: true }"
            :column-auto-width="true"
            :show-row-lines="showRowLines"
            :show-borders="showBorders"
            :row-alternation-enabled="rowAlternationEnabled"
            @exporting="onExporting"
          >
            <DxExport :enabled="true" />
            <DxPaging :page-size="10" />
            <DxPager
              :visible="true"
              :show-page-size-selector="false"
              :show-info="true"
              :show-navigation-buttons="true"
            />
            <DxColumn
              data-field="ID_Customer"
              caption="ID"
              alignment="left"
            />
            <DxColumn
              data-field="cliente"
              caption="Nombre de Cliente"
              alignment="left"
            />
            <DxColumn v-if="mostrarVendedor"
              data-field="vendedor"
              caption="Vendedor/a"
              alignment="left"
            />
            <DxColumn
              :data-field="creditoField"
              caption="Crédito"
              data-type="number"
              cell-template="currencyTemplate"
            />
            <DxColumn
              :data-field="contadoField"
              caption="Contado"
              data-type="number"
              cell-template="currencyTemplate"
            />
            <DxColumn
              :data-field="totalField"
              caption="Total"
              data-type="number"
              cell-template="currencyTemplate"
            />
            <template #currencyTemplate="{ data }">
              <div class="text-right">
                {{ formatCurrency(data.value) }}
              </div>
            </template>
            <template #totalTemplate="{ data }">
              <div class="text-right font-weight-bold">
                {{ formatCurrency(data.value) }}
              </div>
            </template>
            <DxSummary>
              <DxTotalItem
                column="ID_Customer"
                summary-type="count"
                display-format="Clientes: {0}"
              />
              <DxTotalItem
                :column="creditoField"
                summary-type="sum"
                :value-format="{ precision: 2 }"
                display-format="{0}"
              />
              <DxTotalItem
                :column="contadoField"
                summary-type="sum"
                :value-format="{ precision: 2 }"
                display-format="{0}"
              />
              <DxTotalItem
                :column="totalField"
                summary-type="sum"
                :value-format="{ precision: 2 }"
                display-format="{0}"
              />
            </DxSummary>
          </DxDataGrid>
        </GeneralFilter>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxExport,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";
import GeneralFilter from "../GeneralFilter.vue";
import DxButton from "devextreme-vue/button";
import DatePicker from "../../components/DatePicker";
import { multipleCriteriaFilter } from "../../helpers/object";
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver-es';
import moment from "moment";
import spinner from "./spinner.vue";
ChartJS.register(ArcElement, Tooltip, Legend);
export default {
  name: "TopCustomerChart",
  components: {
    DxDataGrid,
    DxColumn,
    DatePicker,
    DxPaging,
    DxButton,
    DxPager,
    GeneralFilter,
    DxExport,
    spinner,
    DxSummary,
    DxTotalItem,
  },
  props:{
    branch:{
      type:Number,
      default: 0,
    },
    ambiente:{
      type:Number,
      default: 1,
    },
    autoLoad: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      start: moment().format("DD/MM/YYYY"),
      end: moment().format("DD/MM/YYYY"),
      panel: 0,
      showCustomer: false,
      topCustomers: [],
      HistorytopCustomers: [],
      topProducts: [],
      activeP: "dia",
      activeC: "dia",
      activePF: "Dias",
      countCustomers: [],
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      search: {filter:''},
      showPageSizeSelector: true,
      topCustomersFiltered: [],
      isFiltered: false,
      dataP: {
        labels: ["Actual", "Anterior", "Dos anteriores"],
        datasets: [
          {
            backgroundColor: ["#41B883", "#E9351", "#00D6FF"],
            data: [10, 10, 10],
          },
        ],
      },
      Currency: null,
      mostrarVendedor: false,
      mostrarIVA: false,
      loading: false,
    };
  },
  mounted() {
    this.Currency = JSON.parse(localStorage.getItem("branch")).Currency;
    if (this.autoLoad) {
      this.getTopCustomers();
    }
    this.search.filter = null;
    //this.getTopProducts();
  },
  methods: {
    formatCurrency(value) {
      if (value === null || value === undefined) return "";
      return new Intl.NumberFormat('en-US', { 
          style: 'currency', 
          currency: 'USD' 
      }).format(value);
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('TopClientes');

      exportDataGrid({
        component: e.component,
        worksheet,
        topLeftCell: { row: 4, column: 1 },
      }).then((cellRange) => {
        // header
        const headerRow = worksheet.getRow(2);
        headerRow.height = 30;
        worksheet.mergeCells(2, 1, 2, 5);

        headerRow.getCell(1).value = 'Top Clientes';
        headerRow.getCell(1).font = { name: 'Segoe UI Light', size: 22 };
        headerRow.getCell(1).alignment = { horizontal: 'center' };

        // footer
        const footerRowIndex = cellRange.to.row + 2;
        const footerRow = worksheet.getRow(footerRowIndex);
        worksheet.mergeCells(footerRowIndex, 1, footerRowIndex, 5);

        footerRow.getCell(1).value = '-';
        footerRow.getCell(1).font = { color: { argb: 'BFBFBF' }, italic: true };
        footerRow.getCell(1).alignment = { horizontal: 'right' };
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'TopClientes.xlsx');
        });
      });
      e.cancel = true;
    },
    setCurrency() {
      this.topCustomers.map((customer) => {
        customer.amountFormatted = `${this.Currency}${customer.amount}`;
      });
    },
    filterHandler(response) {
      this.isFiltered = true;
      this.topCustomers = response;
    },
    clearFilter() {
      this.isFiltered = false;
    },
    filterPromise(filterObj) {
      let filterArray = [
        "ID_Customer",
        "cliente"
      ];
      const data = this.HistorytopCustomers;
      if (this.mostrarVendedor) filterArray.push('vendedor');
      if (!filterObj || filterObj.length == 0) {
        return this.HistorytopCustomers;
      }

      return new Promise((resolve, reject) => {
        try {
          resolve(
            multipleCriteriaFilter(filterArray, filterObj, data)
          );
        } catch (error) {
          console.log(error);
          
          reject(error);
        }
      });
    },
    normalizeTopCustomers(customers = []) {
      return customers.map((customer) => {
        const creditoTotal = Number(customer.CreditoTotal) || 0;
        const creditoTotalWIVA = Number(customer.CreditoTotalWIVA) || 0;
        const contadoTotal = Number(customer.ContadoTotal) || 0;
        const contadoWIVA = Number(customer.ContadoWIVA) || 0;

        return {
          ...customer,
          CreditoTotal: creditoTotal,
          CreditoTotalWIVA: creditoTotalWIVA,
          ContadoTotal: contadoTotal,
          ContadoWIVA: contadoWIVA,
          Total: Number(customer.Total) || 0,
          TotalWIVA: creditoTotalWIVA + contadoWIVA,
        };
      });
    },
    async getTopCustomers() {
      const params ={
        branch: this.branch,
        ambiente: this.ambiente,
        start: this.start,
        end: this.end,
        vendedor: this.mostrarVendedor,
      }
      try {
        this.loading = true;
        const response = await this.$API.dashboard.getTop(params);
        this.HistorytopCustomers = this.normalizeTopCustomers(response);
        this.topCustomers = this.HistorytopCustomers;
      } catch (error) {
        console.warn(error);
        
      }finally{
        this.loading = false;
      }
    },
    getTopCustomersRange() {
      this.$API.dashboard
        .getTopCustomersRange(
          new Date(this.formatDate(this.start)),
          new Date(this.formatDate(this.end))
        )
        .then((response) => {
          this.topCustomers = response;
          this.activeC = "dia";
          this.setCurrency();
        });
    },
    formatDate(date) {
      const parts = date.split("/");
      const aux = parts[0];
      parts[0] = parts[1];
      parts[1] = aux;
      return parts.join("/");
    },
    getTopCustomersw() {
      this.$API.dashboard.getTopCustomersw().then((response) => {
        this.topCustomers = response;
        this.activeC = "semana";
        this.setCurrency();
      });
    },
    getTopCustomersm() {
      this.$API.dashboard.getTopCustomersm().then((response) => {
        this.topCustomers = response;
        this.activeC = "mes";
        this.setCurrency();
      });
    },
    getTopCustomersy() {
      this.$API.dashboard.getTopCustomersy().then((response) => {
        this.topCustomers = response;
        this.activeC = "año(actual)";
        this.setCurrency();
      });
    },
    //end pastel graphic
    getTopProducts() {
      this.$API.dashboard.getProducts().then((response) => {
        this.topProducts = response;
        this.setCurrency();
        this.activeP = "dia";
      });
    },
  },
  computed: {
    creditoField() {
      return this.mostrarIVA ? "CreditoTotalWIVA" : "CreditoTotal";
    },
    contadoField() {
      return this.mostrarIVA ? "ContadoWIVA" : "ContadoTotal";
    },
    totalField() {
      return this.mostrarIVA ? "TotalWIVA" : "Total";
    },
    columnWidth() {    
      return this.$vuetify.breakpoint.smAndDown ? '150px' : 'auto !important';
    },
    customerData() {
      const customers = !this.isFiltered ? this.topCustomers : this.topCustomersFiltered
      return customers.map(customer => {
        return {
          ID_Customer: customer.ID_Customer,
          customerName: customer.Is_a_business ? customer.BusinessName : `${customer.FirstName} ${customer.LastName}`,
          typeBusiness: customer.Is_a_business ? 'Negocio' : 'Cliente',
          email: customer.Is_a_business ? customer.BusinessEmail :customer.Email,
          amountFormatted: customer.amountFormatted
        }
      })
    },
  },
};
</script>
<style scoped>
::v-deep .dx-datagrid-rowsview .dx-column-indicators + .dx-datagrid-text-content,
::v-deep .dx-datagrid-rowsview .dx-row > td {
  text-align: inherit !important; /* Permite que el alignment="right" de la columna funcione */
}
.top-clientes-container {
  min-height: 600px;
  border-radius: 16px;
}

.filter-label {
  font-weight: 600;
  margin-bottom: 4px;
  font-size: 14px;
}

.number-statistics .c-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 40px;
  border-radius: 8px;
}

.dx-theme-generic-typography h3 {
  color: #000000;
}

.table-statistics .purple {
  background-color: purple;
}

.table-statistics .orange {
  background-color: orange;
}

.table-statistics h4 {
  color: #fff;
  padding: 10px 20px;
}

.dx-field {
  display: flex;
  align-items: center;
}
.dx-field-label {
  margin-right: 10px;
}

.dx-data-grid .dx-datagrid-headers, .dx-data-grid .dx-datagrid-rowsview {
  overflow-x: auto;
}
.dx-column{
  min-height: 150px;
}
</style>
